import { array, object, string } from 'yup';
import { PERSON_NAME } from '../../helpers/constants';

const NannyCreateSchema = object().shape({
  first_name: string().required('Please enter your First Name').matches(PERSON_NAME, 'Please enter a valid first name'),
  last_name: string().required('Please enter your Last Name').matches(PERSON_NAME, 'Please enter a valid last name'),
  email: string().email('Enter a valid email').required('Email is required'),
  password: string().min(6, 'Password must contain at least 6 characters').required('Enter your password'),
  mobile_number: string().required('Please enter your phone number'),
  location: object().required('Please enter location'),
  note: string(),
  skills: array(),
  ref1name: string(),
  ref1phone_number: string(),
  ref1email: string(),
  ref2name: string(),
  ref2phone_number: string(),
  ref2email: string(),
  ref3name: string(),
  ref3phone_number: string(),
  ref3email: string(),
  ref4name: string(),
  ref4phone_number: string(),
  ref4email: string(),
  ref5name: string(),
  ref5phone_number: string(),
  ref5email: string(),
  // social_security_number: string(),
  about_nanny: string(),
  residential_address: string(),
  how_soon_start: string(),
  date_of_birth: string(),
  gender: string(),
  type: string(),
  visa_status: string(),
  nanny_experience: string(),
  first_language: string(),
  second_language: string(),
  how_long_in_usa: string(),
  ethnicity: string(),
  educational_entity: string(),
  experience_entity: string(),
  hourlyRate: string(),
  annualSalary: string(),
});

export default NannyCreateSchema;
